import { useEffect, useContext } from 'react';
import { Col, Row } from 'react-bootstrap';
import UpSellingCard from './UpSellingCard';
import { CheckInContext } from "../../context/checkin";
import { usePersistentState } from '../../hooks/usePersistentState';
import { T } from "react-translator-component";

const UpSellingListContainer = ({ cupsList, lang, travelType, currency, checkInId, path = false }) => {
    const { setCrossUpSellingItems, data } = useContext(CheckInContext);
    const [cart, setCart] = usePersistentState(`checkIn-cups-cart+${checkInId}`, {});
    const { inStay } = data;


    const addToCart = (item) => {
        setCart(actual => {
            return { ...actual, [item.id]: item };
        });
    };
    const removeFromCart = (id) => {
        setCart(actual => {
            const _actual = { ...actual };
            if (_actual[id]) {
                delete (_actual[id]);
            }
            return { ..._actual };
        });
    };


    useEffect(() => {
        console.log('11feb - cart', cart)
        setCrossUpSellingItems(Object.values(cart));
    }, [cart]);

    if (!cupsList || cupsList.length === 0) return null;

    const { preferedCupsList, othersCupsList } = cupsList.reduce((acc, cup) => {
        if (cup.onlyNotInStay && inStay) {
            // Skip this cup if onlyNotInStay is true and inStay is true
            return acc;
        }

        if (cup?.travelTypes?.includes(travelType)) {
            acc.preferedCupsList.push(cup);
        } else {
            acc.othersCupsList.push(cup);
        }
        return acc;
    }, { preferedCupsList: [], othersCupsList: [] });

    preferedCupsList.sort((a, b) => a.order - b.order);
    othersCupsList.sort((a, b) => a.order - b.order);



    return (
        <>
            {preferedCupsList && preferedCupsList.length > 0 && (
                <div className='my-2'>
                    <span className="d-block text-center text-muted font-size-sm" style={{ fontSize: 16 }}>{T("cups.preferedList_text")}</span>
                </div>
            )}
            <Row xs={1} md={2} className="g-4 cross-up-selling">
                {preferedCupsList.map((cup, idx) => (
                    <Col key={idx} className='mt-2'>
                        <UpSellingCard cup={cup} lang={lang} cart={cart} addToCart={addToCart} removeFromCart={removeFromCart} currency={currency} path={path} />
                    </Col>
                ))}
            </Row>
            <div className='my-2'>
                {preferedCupsList && preferedCupsList.length === 0 ? (
                    <span className="d-block text-center  font-size-sm" style={{ fontSize: 16 }}>{T("cups.preferedList_text")}</span>
                ) : (
                    <>
                        {othersCupsList && othersCupsList.length > 0 && <span className="d-block text-center text-muted font-size-sm" style={{ fontSize: 16 }}>{T("cups.otherList_text")}</span>}
                    </>
                )}
            </div>
            {othersCupsList && othersCupsList.length > 0 && (
                <Row xs={1} md={2} lg="3" xl="4" className="g-4 cross-up-selling">
                    {othersCupsList.map((cup, idx) => (
                        <Col key={idx} className='mt-2'>
                            <UpSellingCard cup={cup} lang={lang} cart={cart} addToCart={addToCart} removeFromCart={removeFromCart} currency={currency} path={path} />
                        </Col>
                    ))}
                </Row>
            )}
        </>
    );
}

export default UpSellingListContainer;
